var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3705_21929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1H6.5C3.46243 1 1 3.46243 1 6.5V17.5C1 20.5376 3.46243 23 6.5 23H17.5C20.5376 23 23 20.5376 23 17.5V6.5C23 3.46243 20.5376 1 17.5 1Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9567 11.4133C16.0802 12.2455 15.938 13.0955 15.5505 13.8423C15.163 14.5891 14.5499 15.1947 13.7984 15.5729C13.0468 15.9512 12.1952 16.0829 11.3645 15.9492C10.5339 15.8155 9.7665 15.4234 9.17158 14.8284C8.57666 14.2335 8.18447 13.4661 8.05081 12.6355C7.91714 11.8048 8.0488 10.9532 8.42706 10.2016C8.80533 9.45012 9.41092 8.83701 10.1577 8.44951C10.9045 8.06201 11.7545 7.91986 12.5867 8.04327C13.4357 8.16915 14.2216 8.56473 14.8284 9.17158C15.4353 9.77842 15.8309 10.5643 15.9567 11.4133Z",
    stroke: "#9E9E9E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3705_21929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.33560f7679cf141dae311c4d321ea586.svg";
export { ForwardRef as ReactComponent };